<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 v-if="me" class="font-size--24">
        비상금 신청이 완료되었습니다.
      </h1>
    </section>
    <section class="mt-4 mb-10">
      <h2 v-if="me" class="font-size--20">
        사업자대출 과다 여부만 확인하고,
      </h2>
      <h2 v-if="me" class="font-size--20">
        담당자가 연락 드리겠습니다.
      </h2>
    </section>
    <section>
      <ul class="font-size--14 color--nice-grey outer">
        <li>비상금 대출은 P2P 방식으로 온라인 모집하여 지급합니다.</li>
        <li>모집 기간은 5일이며, 신청하신 금액 중 일부만 모집-지급될 수 있습니다.</li>
      </ul>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  computed: {
    ...mapState('auth', ['me']),
  },
  async created() {
    _meta({
      titles: ['300만원비상금대출 완료'],
    })
    if (await redirectSignupManage()) {
      return
    }
  },
  watch: {
    me: {
      deep: true,
      immediate: true,
      async handler() {
        
      },
    },
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    async fastLoan300() {
      await this.$router.push('/loan/fast-loan-300')
    },
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
